export const zeroWidthSpace = '\u{200B}';
const zeroWidthSpaceDigitRegex = /(.*)\u{200B}(\d+)$/iu;

function duplicateName(str: string, count: number) {
  return `${str.trim()} ${zeroWidthSpace}${count}`;
}

// For things duplicated in the app, we want a standard way of naming, being
// `{name} {count}`. Customers could easily have an object name with a digit,
// so to determine whether to increase the count of a duplicate or not, we
// use a zero width space in our count.  If an object name has a zero width
// space and number, it's something we created and can safely increment.
export function createDuplicateName(originalName: string): string {
  const found = originalName.match(zeroWidthSpaceDigitRegex);
  if (found) {
    const [_, name, current] = found;
    return duplicateName(name, Number(current) + 1);
  }
  return duplicateName(originalName, 1);
}
